import React, { useState } from "react";
import Footer from "../components/developer_footer.jsx";
import Header from "../components/developer_header.jsx";

const CertificationJourneyLayout = () => {
  const [notification, setNotification] = useState({
    visible: false,
    message: ""
  });

  const showNotification = (message) => {
    setNotification({ visible: true, message });
    setTimeout(() => {
      setNotification({ visible: false, message: "" });
    }, 3000);
  };

  // Separate Building Blocks into its own category
  const beginnerCertifications = [
    "Building Blocks",
  ];

  const courseworkCertifications = [
    "NETS Certification Process (Sandbox)",
    "NETS Certification Process (Staging)",
    "NETS Certification Process (Production)",
  ];

  const projectCertifications = [
    "Project 'Go-Live' NETS Certification Process",
  ];

  const ArrowRightIcon = () => (
    <svg className="w-4 h-4 ml-2" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z" clipRule="evenodd"></path>
    </svg>
  );

  return (
    <div className="min-h-screen bg-gray-50">
      <Header/>
      
      {/* Notification - responsive positioning and text size */}
      {notification.visible && (
        <div className="fixed top-4 right-4 bg-blue-500 text-white px-4 sm:px-6 py-2 sm:py-3 rounded-md shadow-lg z-50 transition-opacity duration-300 text-sm sm:text-base max-w-[90%] sm:max-w-md">
          {notification.message}
        </div>
      )}

      {/* Breadcrumb - improved padding for mobile */}
      <div className="bg-gray-100 py-2 sm:py-3">
        <div className="container mx-auto px-4 sm:px-6">
          <p className="text-sm text-gray-600 text-left">
            <a href="/get-started" className="text-blue-600 hover:underline">Get Started</a> &gt; Certification Journey
          </p>
        </div>
      </div>

      {/* Main Content - improved responsive layout */}
      <main className="container mx-auto px-4 sm:px-6 py-6 sm:py-12">
        {/* Stacked layout on mobile, grid on larger screens */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 sm:gap-8">
          {/* Sidebar - shown at top on mobile, left side on desktop */}
          <aside className="bg-white rounded-lg shadow-md p-4 sm:p-6 mb-4 lg:mb-0">
            <h3 className="text-base sm:text-lg font-semibold text-gray-800 mb-3 sm:mb-4 text-left">Get Started</h3>
            <div className="space-y-4 sm:space-y-6">
              {/* Add Beginner Process section to sidebar */}
              <div>
                <h4 className="text-sm font-semibold text-gray-600 mb-2 text-left">Beginner Process</h4>
                <ul className="space-y-2">
                  {beginnerCertifications.map((cert, index) => (
                    <li key={index} className="text-gray-700 text-sm flex items-center">
                      <span className="inline-block w-3 h-3 sm:w-4 sm:h-4 bg-gray-300 rounded-full mr-2"></span>
                      <span className="text-sm">{cert}</span>
                    </li>
                  ))}
                </ul>
              </div>
              <div>
                <h4 className="text-sm font-semibold text-gray-600 mb-2 text-left">Coursework Certification(s) Process</h4>
                <ul className="space-y-2">
                  {courseworkCertifications.map((cert, index) => (
                    <li key={index} className="text-gray-700 text-sm flex items-center">
                      <span className="inline-block w-3 h-3 sm:w-4 sm:h-4 bg-gray-300 rounded-full mr-2"></span>
                      <span className="text-sm">{cert}</span>
                    </li>
                  ))}
                </ul>
              </div>
              <div>
                <h4 className="text-sm font-semibold text-gray-600 mb-2 text-left">Developer Project Certification(s) Process</h4>
                <ul className="space-y-2">
                  {projectCertifications.map((cert, index) => (
                    <li key={index} className="text-gray-700 text-sm flex items-center">
                      <span className="inline-block w-3 h-3 sm:w-4 sm:h-4 bg-gray-300 rounded-full mr-2"></span>
                      <span className="text-sm">{cert}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </aside>

          {/* Main Section - takes full width on mobile, 2/3 on desktop */}
          <section className="lg:col-span-2">
            <h2 className="text-2xl sm:text-3xl font-bold text-gray-800 mb-4 sm:mb-6">Let's begin your Full-Stack FinTech certification journey!</h2>

            <div className="space-y-6 sm:space-y-8">
              {/* Beginner Process Section */}
              <div>
                <h3 className="text-base sm:text-lg font-semibold text-gray-800 mb-3 sm:mb-4">Beginner Process</h3>
                <ul className="space-y-3 sm:space-y-4">
                  {beginnerCertifications.map((cert, index) => (
                    <li key={index} className="bg-white rounded-lg shadow-md p-3 sm:p-4">
                      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between">
                        <span className="text-sm sm:text-base text-gray-700 mb-2 sm:mb-0">{cert}</span>
                        <button
                          onClick={() => (window.location.href = "/certification-journey/building-block")}
                          className="text-blue-600 hover:text-blue-800 font-medium flex items-center text-sm sm:text-base py-1"
                        >
                          View Details <ArrowRightIcon />
                        </button>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>

              {/* Coursework Certifications */}
              <div>
                <h3 className="text-base sm:text-lg font-semibold text-gray-800 mb-3 sm:mb-4">Coursework Certification(s) Process</h3>
                <ul className="space-y-3 sm:space-y-4">
                  {courseworkCertifications.map((cert, index) => (
                    <li key={index} className="bg-white rounded-lg shadow-md p-3 sm:p-4">
                      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between">
                        <span className="text-sm sm:text-base text-gray-700 mb-2 sm:mb-0">{cert}</span>
                        {cert === "NETS Certification Process (Sandbox)" ? (
                          <button
                            onClick={() => (window.location.href = "/certification-journey/sandbox")}
                            className="text-blue-600 hover:text-blue-800 font-medium flex items-center text-sm sm:text-base py-1"
                          >
                            View Details <ArrowRightIcon />
                          </button>
                        ) : cert === "NETS Certification Process (Staging)" ? (
                          <button
                            onClick={() => (window.location.href = "/certification-journey/staging")}
                            className="text-blue-600 hover:text-blue-800 font-medium flex items-center text-sm sm:text-base py-1"
                          >
                            View Details <ArrowRightIcon />
                          </button>
                        ) : (
                          <button
                            onClick={() => showNotification(`${cert} details coming soon!`)}
                            className="text-gray-400 font-medium flex items-center cursor-not-allowed text-sm sm:text-base py-1"
                            disabled
                          >
                            View Details <ArrowRightIcon />
                          </button>
                        )}
                      </div>
                    </li>
                  ))}
                </ul>
              </div>

              {/* Project Certifications */}
              <div>
                <h3 className="text-base sm:text-lg font-semibold text-gray-800 mb-3 sm:mb-4">Developer Project Certification(s) Process</h3>
                <ul className="space-y-3 sm:space-y-4">
                  {projectCertifications.map((cert, index) => (
                    <li key={index} className="bg-white rounded-lg shadow-md p-3 sm:p-4">
                      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between">
                        <span className="text-sm sm:text-base text-gray-700 mb-2 sm:mb-0">{cert}</span>
                        <button
                          onClick={() => showNotification(`${cert} details coming soon!`)}
                          className="text-gray-400 font-medium flex items-center cursor-not-allowed text-sm sm:text-base py-1" 
                          disabled
                        >
                          View Details <ArrowRightIcon />
                        </button>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </section>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default CertificationJourneyLayout;